module.exports = __webpack_public_path__ + "static/media/golfer-8-b.32bd9226.png";